module.exports = __webpack_public_path__ + "static/media/king.20182d30.png";